<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ch-title">TABLE OF CONTENTS</h2>
<p class="toc-chapt"><span href="#/xhtml/fm03" title="Link target outside of Sample"><em class="italic">Foreword</em></span></p>
<p class="toc-chap"><span href="#/xhtml/fm04" title="Link target outside of Sample"><em class="italic">Acknowledgements</em></span></p>
<p class="toc-chap"><span href="#/xhtml/fm05" title="Link target outside of Sample"><em class="italic">Proven Player Introduction</em></span></p>
<p class="toc-chapt"><span href="#/xhtml/chap01" title="Link target outside of Sample">The Proven Player</span></p>
<p class="toc-chap"><span href="#/xhtml/chap02" title="Link target outside of Sample">Passion</span></p>
<p class="toc-chap"><span href="#/xhtml/chap03" title="Link target outside of Sample">Resilient</span></p>
<p class="toc-chap"><span href="#/xhtml/chap04" title="Link target outside of Sample">Opportunistic</span></p>
<p class="toc-chap"><span href="#/xhtml/chap05" title="Link target outside of Sample">Value</span></p>
<p class="toc-chap"><span href="#/xhtml/chap06" title="Link target outside of Sample">Eternal Perspective</span></p>
<p class="toc-chap"><span href="#/xhtml/chap07" title="Link target outside of Sample">Network</span></p>
<p class="toc-chap"><span href="#/xhtml/chap08" title="Link target outside of Sample">Persistence</span></p>
<p class="toc-chap"><span href="#/xhtml/chap09" title="Link target outside of Sample">Lead</span></p>
<p class="toc-chap"><span href="#/xhtml/chap10" title="Link target outside of Sample">Alert</span></p>
<p class="toc-chap"><span href="#/xhtml/chap11" title="Link target outside of Sample">Yield</span></p>
<p class="toc-chap"><span href="#/xhtml/chap12" title="Link target outside of Sample">Excellence</span></p>
<p class="toc-chap"><span href="#/xhtml/chap13" title="Link target outside of Sample">Resolve</span></p>
<p class="toc-chapt"><span href="#/xhtml/bm01" title="Link target outside of Sample"><em class="italic">Addendum</em></span></p>
<p class="toc-chap"><span href="#/xhtml/bm02" title="Link target outside of Sample"><em class="italic">Proven Player Game Changer</em></span></p>
<p class="toc-chap"><span href="#/xhtml/bm03" title="Link target outside of Sample"><em class="italic">About the Author</em></span></p>
<p class="toc-chap"><span href="#/xhtml/bm04" title="Link target outside of Sample"><em class="italic">Journal</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2960c1c4